/* eslint-disable better-mutation/no-mutation */

type Options = {
    timeout?: number;
    dataAttributes?: Record<string, string>;
    key?: string;
    unload?: () => void;
};

export function loadScript(src: string, options: Options = {}) {
    const optionsWithDefaults = {
        timeout: options.timeout || 0,
        dataAttributes: options.dataAttributes || {}
    };
    return new Promise<void>((resolve, reject) => {
        if (document.querySelector(`head > script[src="${src}"]`) !== null) {
            resolve();
            return;
        }

        if (options.key) {
            const scriptWithKey = document.querySelector(
                `head > script[data-key="${options.key}"]`
            );

            if (scriptWithKey) {
                document.head.removeChild(scriptWithKey);
                options.unload?.();
            }
        }

        const script = document.createElement('script');

        let timeoutTimer: ReturnType<typeof setTimeout>;
        if (optionsWithDefaults.timeout > 0) {
            timeoutTimer = setTimeout(() => {
                script.onload = null;
                script.onerror = null;
                document.head.removeChild(script);
                options.unload?.();
                reject(new Error('SCRIPT_LOAD_TIMEOUT'));
            }, optionsWithDefaults.timeout);
        }

        script.src = src;

        if (options.key) {
            optionsWithDefaults.dataAttributes = {
                ...optionsWithDefaults.dataAttributes,
                key: options.key
            };
        }
        for (const attribute of Object.keys(
            optionsWithDefaults.dataAttributes
        )) {
            script.setAttribute(
                `data-${attribute}`,
                optionsWithDefaults.dataAttributes[attribute]
            );
        }
        script.async = true;
        script.onload = () => {
            if (timeoutTimer) clearTimeout(timeoutTimer);
            resolve();
        };
        script.onerror = (error) => {
            if (timeoutTimer) clearTimeout(timeoutTimer);
            reject(error);
        };
        document.head.appendChild(script);
    });
}
